<template>
    <router-view />
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
    name: 'App',
    computed: {
        ...mapGetters( 'auth', [ 'loggedIn' ] )
    },
    mounted() {
        setTimeout( () => {
            this.init()
        }, 2500 )
    },
    methods: {
        ...mapActions( 'users', [ 'setUserData' ] ),
        init() {
            this.setUserData()
            this.$i18n.locale = document.cookie.lang
            this.$nextTick( () => {
                if ( !this.loggedIn ) {
                    this.$router.push( { name: 'login' } )
                }
            } )
        }
    }
}
</script>
<style>
    .vs__dropdown-toggle{
        border: 1px solid #e5e6e7 !important;
        border-radius: 1px !important;
        padding: 6px 12px !important;
    }
</style>
